// extracted by mini-css-extract-plugin
export default {"profileInfo":"Address_profileInfo__fITtU","row":"Address_row__Lqk3m","rowSingleInfo":"Address_rowSingleInfo__s3QQ2"};